import RegisterImage from '@/assets/images/fx/Torfx_register.png';
import RateImage from '@/assets/images/fx/Torfx_rate.png';
import TransferImage from '@/assets/images/fx/Torfx_transfer.png';

export const steps = [
  {
    id: 1,
    title: 'Register',
    text: 'Open an account in minutes online or over the phone',
    icon: RegisterImage,
  },
  {
    id: 2,
    title: 'Get your Rate',
    text: 'Secure an exchange rate online or with your Account Manager',
    icon: RateImage,
  },
  {
    id: 3,
    title: 'Make a transfer',
    text: `Send us the funds to exchange and we'll do the rest`,
    icon: TransferImage,
  },
];
